<template>
    <form-container header-text="Pass-Druckstatus ändern" :width="600" :action="action"
                    :valid-actions="['drucken']"
                    header-icon="mdi-printer" @save="save"
                    button-ok="Speichern" button-cancel="Abbrechen"
                    buttonOkColor="primary">
        <v-card-text class="px-6" v-if="actionObject">
            <v-data-table v-if="printStatus" :headers="headers" :items="printStatus.passList"
                          :items-per-page="20" hide-default-footer>
                <template v-slot:item.waitingForPassPrint="{ item }">
                    <v-checkbox v-model="item.waitingForPassPrint"/>
                </template>
                <template v-slot:item.isDuplikat="{ item }">
                    <v-checkbox v-if="item.isDuplikat!==undefined" v-model="item.isDuplikat"/>
                </template>
            </v-data-table>
        </v-card-text>
    </form-container>
</template>

<script>
    import FormContainer from "../../../components/form/formContainer";
    import SPIELER_MEMBERSHIP_HANDLER from "@/services/data/spieler/spielerMembershipHandler";
    import {PrintPaesseEditPrintStatus} from "@/services/print/printPaesseEditPrintStatus";

    export default {
        components: {FormContainer},
        name: "spieler-print",
        props: ['action', 'actionObject'],
        data: () => ({
            printStatus: null,
            headers: [
                { text: 'Passtyp', value: 'label' },
                { text: 'letzter Druck', value: 'tsLastPassPrint' },
                { text: 'wartet auf Druck', value: 'waitingForPassPrint' },
                { text: 'ist Duplikat', value: 'isDuplikat' },
            ],
        }),
        computed: {
            memberships(){ return this.actionObject.local?.spieler?.memberships},
            membership(){
                if ( !this.memberships ) return
                const currentLeihe = SPIELER_MEMBERSHIP_HANDLER.getCurrentLeihe(this.memberships)
                return currentLeihe ? currentLeihe : SPIELER_MEMBERSHIP_HANDLER.getMembershipForTodayOrFuture(this.memberships)
            },
            spielerPassLabel(){ return this.membership?.leihe ? 'Leihspielerpass' : 'Spielerpass'; }
        },
        methods: {
            async save(){
                this.printStatus.saveChanges()
                window.history.back()
            },
            setPrintStatus(){
                this.printStatus = new PrintPaesseEditPrintStatus(this.actionObject.local.spieler, this.spielerPassLabel)
            }
        },
        watch: {
            actionObject(to){
                this.setPrintStatus(to)
            }
        }
    }
</script>

<style scoped>

</style>